import axiosClient from "api/axiosClient";

const photoService = {
    /**
     * Uploads a photo blob to POST /files/photos
     * @param {Blob} blob - cropped image blob
     * @param {string} filename
     * @returns {Promise<any>} response data from the API
     */
    upload: async (blob, filename = "photo.jpg") => {
        const formData = new FormData();
        formData.append("file", blob, filename);

        const { data } = await axiosClient.post("/files/photos", formData, {
            // undefined removes axiosClient's default "application/json" header
            // so the browser sets "multipart/form-data" with the correct boundary
            headers: { "Content-Type": undefined }
        });

        return data;
    },

    /**
     * Fetches a photo through the authenticated axios client (adds the Bearer
     * token) instead of a plain <img src>, which can't send that header.
     * Use this as PhotoUploadCrop's `fetchImage` prop when your files endpoint
     * requires auth to view, not just to upload.
     * @param {string} url - full URL or path to the photo (e.g. form.photoUrl)
     * @returns {Promise<Blob>}
     */
    fetch: async (url) => {
        const { data } = await axiosClient.get(url, { responseType: "blob" });
        return data;
    }
};

export default photoService;
